<template>
  <div class="rating" :style="{ fontSize: `${iconSize}px` }">
    <i v-for="_ in r1" class="icon icon-star"></i>
    <i v-if="r2 > 0" class="icon icon-star" :style="starFragmentStyle"></i>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const iconSize = 20
const { rating } = defineProps<{ rating: number }>()
const [r1, r2] = splitNumber(rating)

const starFragmentStyle = computed(() => ({
  overflow: 'hidden',
  width: `${iconSize * r2}px`,
}))

function splitNumber(num: number) {
  const whole = Math.trunc(num)
  return [whole, num - whole]
}
</script>

<style lang="scss" scoped>
.rating {
  display: flex;
  align-items: center;
  gap: $spacing-1;
  line-height: 1;

  .icon {
    color: $yellow;
  }
}
</style>
